import { useDispatch, useSelector } from 'react-redux';
import { Table } from '@quintoandar-tokko/jopijs';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import parentStyles from '../dashboardTables.module.scss';
import specificStyles from './productionRateTable.module.scss';
import { setPerformanceModals } from '@/store/slices/components/dashboard/DashboardSlice';
import HeaderCell from '../components/HeaderCell';
import { TABLE_SORT_FIELDS } from '../../constants';
import ProductionRateGroupedTableContent from './ProductionRateGroupedTableContent';
import ProductionRateNonGroupedTableContent from './ProductionRateNonGroupedTableContent';
import useTrackPerformanceTable from '@/components/Dashboard/customHooks/useTrackDashboard';
import { TRACK_ELEMENT } from '@/components/Dashboard/constants/track';

export default function ProductionRateTable() {
  const dispatch = useDispatch();

  const { productionRate } = useSelector(
    (state) => state.DashboardSlice.performanceModals
  );
  const track = useTrackPerformanceTable();

  const headers = [
    {
      id: 1,
      title: Trans(translations, 'Agent'),
      subtitle: Trans(translations, 'Branch'),
      field: TABLE_SORT_FIELDS.AGENT_NAME,
    },
    {
      id: 2,
      title: Trans(translations, 'ProductionRate'),
      field: TABLE_SORT_FIELDS.PRODUCTION_RATE,
    },
    {
      id: 3,
      title: Trans(translations, 'DashboardTableTitle.Appraised'),
      field: TABLE_SORT_FIELDS.APPRAISED,
    },
    {
      id: 4,
      title: Trans(translations, 'DashboardTableTitle.Entered'),
      field: TABLE_SORT_FIELDS.ENTERED,
    },
    {
      id: 5,
      title: Trans(translations, 'DashboardTableTitle.Fallen'),
      field: TABLE_SORT_FIELDS.FALLEN,
    },
    {
      id: 6,
      title: Trans(translations, 'InProgress'),
      field: TABLE_SORT_FIELDS.IN_PROGRESS,
    },
  ];

  const handleCellClick = (header) => {
    if (!header.field) return;

    dispatch(
      setPerformanceModals({
        key: 'productionRate',
        subkey: 'sortBy',
        value: header.field,
      })
    );
    track.productionRate(TRACK_ELEMENT.COLUMN_ORDER);
  };

  return (
    <Table
      id="production-rate-table"
      className={`${parentStyles.table} ${specificStyles.productionRateTable}`}
    >
      <Table.Header className={parentStyles.tableHeader}>
        {headers.map((header) => (
          <HeaderCell
            key={header.id}
            id={header.id}
            title={header.title}
            subtitle={header.subtitle}
            field={header.field}
            sortBy={productionRate.sortBy}
            sortDirection={productionRate.sortDirection}
            onClick={() => handleCellClick(header)}
          />
        ))}
      </Table.Header>

      {productionRate.groupByBranch ? (
        <ProductionRateGroupedTableContent headers={headers} />
      ) : (
        <ProductionRateNonGroupedTableContent headers={headers} />
      )}
    </Table>
  );
}
